import { useEffect, useRef } from "react"
import { matchPath, useLocation, useNavigate } from "react-router-dom"
import { clearGuestState, isGuestThread, setSignedInHint, useAuthGate } from "@/lib/authGate"

/**
 * Ends guest mode when the visitor signs in. A guest thread belongs to the guest system user and cannot
 * be continued by an account, so from one the visitor lands on "/" with the guest's question prefilled.
 */
export function GuestSession() {
  const { signedIn } = useAuthGate()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const pathRef = useRef(pathname)
  pathRef.current = pathname
  setSignedInHint(signedIn)

  useEffect(() => {
    if (!signedIn) return
    const id = matchPath("/nira/:threadId", pathRef.current)?.params.threadId
    const onGuestThread = !!id && isGuestThread(id, false)
    const question = clearGuestState()
    if (onGuestThread) navigate("/ask", { replace: true, state: question ? { prefill: question } : null })
  }, [signedIn, navigate])

  return null
}
